//import React from 'react';

import React, {useEffect, useState} from 'react';
import Sidebar from '../Sidebar/Sidebar'; 
//import ValidationErrors from '../../Common/ValidationErrors'
import AddressModal from './AddressModal';
import { fetchAddresses,openModal,deleteAddress } from '../../../redux/slices/Customer/AddressesSlice';
import {useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
const  Addresses = () => { 
   // const {loggedInUser} = useSelector((state:any) => state.auth) 
    const {addresses,modalShow} = useSelector((state:any) => state.customerAddresses) 
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    const [formType, setFormType] = useState('New')
    const [selectedAddress, setSelectedAddress] = useState({} as any)
 
    const manageAddAddress =() => {
        dispatch(openModal());
    }
    const handleClick = (type,address) => {
        setFormType(type);
        setSelectedAddress(address);
        type === "Edit" &&  dispatch(openModal());
    }
    const handleRemoveAddress = (id) => {
        dispatch(deleteAddress(id))
    }
    useEffect(() => {
        dispatch(fetchAddresses())
    },[dispatch])
  return (
    <div className="page-content bg-light">
        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
            <div className="container">
                <div className="dz-bnr-inr-entry">
                    <h1>My Account</h1>
                    <nav aria-label="breadcrumb" className="breadcrumb-row">
                        <ul className="breadcrumb">
                        <li key="home" className="breadcrumb-item"><span> Home</span></li>
                        <li key="addressesLink" className="breadcrumb-item">Addresses</li>
                        </ul>
                    </nav>
                </div>
            </div>	
        </div> 
        <div className="content-inner-1">
			<div className="container">
                <div className="row">
                    <Sidebar selectedLink={"My Addresses"}/>
                    {addresses !== null &&
                     <div className="col-xl-8 account-wrapper">
                        <div className="row">
                            <div className="col-12 m-b30">
                                <p className="m-b10">The following addresses will be used on the checkout page.</p>
                                {/* <p className='errorText'>{displayValidations && <ValidationErrors errors={[errorMessage]}/>}</p> */}
                            </div>
                            {addresses && addresses.map((address) => 
                                <div key={address.id} className="col-md-6 m-b30">
                                    <div className="address-card cursor-pointer">
                                        <div className="account-address-box ">
                                            <h6 className="mb-3">Address</h6>
                                            <ul>
                                                <li key="name">{address.first_name} {address.last_name}</li>
                                                <li key="address1">{address.address1}</li>
                                                <li key="address2">{address.address2}</li>
                                                <li key="city">{address.city}, {address.state.name}, {address.country.name}, {address.zipcode}</li>
                                                <li key="mobile">{address.mobile}, {address.alternate_mobile}</li>
                                            </ul>
                                        </div>
                                        <div className="account-address-bottom  ">   
                                            <button onClick={() => handleClick("Edit", address)} className="d-block me-3 removeBtnBG"><i className="fa-solid fa-pen me-2"></i>Edit</button>                                
                                            <button onClick={() => handleRemoveAddress(address.id)} className="d-block me-3 removeBtnBG"><i className="fa-solid fa-trash-can me-2"></i>Remove</button>
                                        </div>
                                    </div>
                                </div>
                            )} 
                            <div className="col-12">
                                <div className="account-card-add">
                                    <div className="account-address-add">
                                        <svg id="Line" height="50" viewBox="0 0 64 64" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m59.28775 26.0578-7.30176-6.251v-11.72068a.99973.99973 0 0 0 -1-1h-7.46a.99974.99974 0 0 0 -1 1v3.60693l-7.2109-6.17675a5.07688 5.07688 0 0 0 -6.6416 0l-23.97314 20.54345a2.04251 2.04251 0 0 0 1.32226 3.56787h5.98047v18.92188a8.60569 8.60569 0 0 0 8.59082 8.60059h10.481a1.00019 1.00019 0 0 0 -.00006-2h-10.48094a6.60308 6.60308 0 0 1 -6.59082-6.60059v-19.92188a1.00005 1.00005 0 0 0 -1-1l-6.99951-.05078 23.97119-20.542a3.08781 3.08781 0 0 1 4.03955 0l8.86133 7.59082a1.00655 1.00655 0 0 0 1.65039-.75934v-4.7802h5.46v11.18066a1.00013 1.00013 0 0 0 .34961.75928l7.63184 6.60156h-6.98148a.99974.99974 0 0 0 -1 1v3.7002a1.00019 1.00019 0 0 0 2-.00006v-2.70014h5.98145a2.03152 2.03152 0 0 0 1.32031-3.56982z"/><path d="m43.99564 33.718a13.00122 13.00122 0 0 0 .00012 26.00244c17.24786-.71391 17.24231-25.29106-.00012-26.00244zm.00012 24.00244c-14.59461-.60394-14.58984-21.40082.00006-22.00244a11.00122 11.00122 0 0 1 -.00006 22.00244z"/><path d="m49.001 45.71942h-4v-4.00049a1.00019 1.00019 0 0 0 -2 0v4.00049h-4a1.00019 1.00019 0 0 0 .00006 2h3.99994v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>
                                    </div>       
                                    <h4 className="mb-3">Add New Address</h4>                             
                                    <button className="btn btn-primary px-5" onClick={() => manageAddAddress()}>Add</button>
                                </div>
                            </div>
                        </div>
                   </div>
                    } 
				</div>
      		</div>
	    </div>
        {modalShow && <AddressModal formType={formType} selectedAddress={selectedAddress} />}

    </div>
  );
}

export default Addresses;

 
